export const FETCH_MISSING_APP_SUCCESS = 'FETCH_MISSING_APP_SUCCESS';
export const FETCH_MISSING_APP_REQUEST = 'FETCH_MISSING_APP_REQUEST';
export const FETCH_MISSING_APP_FAILURE = 'FETCH_MISSING_APP_FAILURE';

export const UPDATE_MISSING_APP_REQUEST = 'UPDATE_MISSING_APP_REQUEST';
export const UPDATE_MISSING_APP_SUCCESS = 'UPDATE_MISSING_APP_SUCCESS';
export const UPDATE_MISSING_APP_FAILURE = 'UPDATE_MISSING_APP_FAILURE';

export const SEARCH_MISSING_APP_REQUEST = 'SEARCH_MISSING_APP_REQUEST';
export const SEARCH_MISSING_APP_SUCCESS = 'SEARCH_MISSING_APP_SUCCESS';
export const SEARCH_MISSING_APP_FAILURE = 'SEARCH_MISSING_APP_FAILURE';

export const FETCH_RESOLVE_AND_UNRESOLVE_SUCCESS = 'FETCH_RESOLVE_AND_UNRESOLVE_SUCCESS';
export const FETCH_RESOLVE_AND_UNRESOLVE_REQUEST = 'FETCH_RESOLVE_AND_UNRESOLVE_REQUEST';
export const FETCH_RESOLVE_AND_UNRESOLVE_FAILURE = 'FETCH_RESOLVE_AND_UNRESOLVE_FAILURE';

export const ADD_MISSING_APP = 'ADD_MISSING_APP';
export const UPDATE_LOCAL_MISSING_APP = "UPDATE_LOCAL_MISSING_APP";


export const fetchMissingAppRequest = (page, limit) => ({
  type: FETCH_MISSING_APP_REQUEST,
  payload: { page, limit },
});

export const fetchMissingAppSuccess = (missingApp) => ({
  type: FETCH_MISSING_APP_SUCCESS,
  payload: missingApp,
});

export const fetchMissingAppFailure = (error) => ({
  type: FETCH_MISSING_APP_FAILURE,
  payload: error,
});

export const fetchResolveAndUnResolveRequest = () => ({
  type: FETCH_RESOLVE_AND_UNRESOLVE_REQUEST,
});

export const fetchResolveAndUnResolveSuccess = (resolveUnResolve) => ({
  type: FETCH_RESOLVE_AND_UNRESOLVE_SUCCESS,
  payload: resolveUnResolve,
});

export const fetchResolveAndUnResolveFailure = (error) => ({
  type: FETCH_RESOLVE_AND_UNRESOLVE_FAILURE,
  payload: error,
});

export const updateMissingAppRequest = (missingApp) => ({
  type: UPDATE_MISSING_APP_REQUEST,
  payload: missingApp,
});

export const updateMissingAppSuccess = (missingApp) => ({
  type: UPDATE_MISSING_APP_SUCCESS,
  payload: missingApp,
});

export const updateMissingAppFailure = (error) => ({
  type: UPDATE_MISSING_APP_FAILURE,
  payload: error,
});

export const searchMissingAppRequest = (searchTerm) => ({
  type: SEARCH_MISSING_APP_REQUEST,
  payload: { searchTerm },
});

export const searchMissingAppSuccess = (missingApp) => ({
  type: SEARCH_MISSING_APP_SUCCESS,
  payload: missingApp,
});

export const searchMissingAppFailure = (error) => ({
  type: SEARCH_MISSING_APP_FAILURE,
  payload: error,
});

export const addMissingAppRequest = (newApp) => ({
  type: ADD_MISSING_APP,
  payload: newApp,
});


export const updateLocalMissingApp = (updatedApp) => ({
  type: UPDATE_LOCAL_MISSING_APP,
  payload: updatedApp,
});
